import { EndScreen } from './end-screen';
import { EndScreenType } from './end-screen-types';

interface AppPreviewContent {
  icon: string;
  name: string;
}

interface EndScreenAppPreviewConfig {
  endScreen?: {
    closeBtn?: {
      delay?: number;
      size?: number;
    };
    duration?: number;
  };
  closeBtn?: {
    autoCloseDelay?: number;
  };
}

export class EndScreenAppPreview extends EndScreen {
  content: AppPreviewContent;

  constructor({
    config,
    content
  }: {
    config: EndScreenAppPreviewConfig;
    content: AppPreviewContent;
  }) {
    super({ config });
    this.type = EndScreenType.APP_PREVIEW;
    this.content = content;
    this.duration = this._getAppPreviewDuration(config);
  }

  isValid(): boolean {
    const hasContent = Boolean(
      this.content && this.content.icon && this.content.name
    );
    const hasDuration = this.duration > 0;

    return hasContent && hasDuration;
  }

  _getAppPreviewDuration(config: EndScreenAppPreviewConfig): number {
    const managedDuration = this.duration;
    const vastDuration =
      config && config.endScreen && config.endScreen.duration;

    return managedDuration || vastDuration || 0;
  }
}
